// extracted by mini-css-extract-plugin
export default {"footer":"InfoEditModal_footer__M1dYS","cancel_btn":"InfoEditModal_cancel_btn__cLKrR"};